module.exports = __webpack_public_path__ + "img/pool-8-ball.b733bba2.svg";